import { Trash2, TrendingUp, History } from 'lucide-react'
import { Badge } from '@/components/ui/Badge'
import type { SegmentTab } from '@/components/ui/page-toolbar'
import type { RocketTab } from '@/hooks/useRocketSearch'

export function buildRocketTabs(
  pipelineCount: number,
  historyCount: number,
  trashCount: number,
): SegmentTab<RocketTab>[] {
  return [
    {
      id: 'pipeline',
      label: (
        <span className="inline-flex items-center gap-1.5">
          Pipeline Ativo
          <Badge variant="muted" className="text-[10px] px-1.5 py-0">
            {pipelineCount}
          </Badge>
        </span>
      ),
      icon: TrendingUp,
    },
    {
      id: 'history',
      label: (
        <span className="inline-flex items-center gap-1.5">
          Históricos
          <Badge variant="muted" className="text-[10px] px-1.5 py-0">
            {historyCount}
          </Badge>
        </span>
      ),
      icon: History,
    },
    {
      id: 'trash',
      label: (
        <span className="inline-flex items-center gap-1.5">
          Lixeira
          {trashCount > 0 && (
            <Badge variant="danger" className="text-[10px] px-1.5 py-0">
              {trashCount}
            </Badge>
          )}
        </span>
      ),
      icon: Trash2,
    },
  ]
}
